export default {
  computed: {
    channelId() {
      return this.$bus && this.$bus.channelId
    },
    channelMsg() {
      return this.$bus && this.$bus.channelConfig
    },
    userInfo() {
      const info =
        localStorage.getItem('info') && JSON.parse(localStorage.getItem('info'))
      return (this.$bus && this.$bus.userInfo) || info
    },
    otherInfo() {
      return this.$bus && this.$bus.userOtherInfo
    }
  },
  methods: {
    showLoading(text = '正在加载') {
      return new Promise(resolve => {
        this.$bus.$emit('SET_LOADING', { show: true, text: text })
        resolve()
      })
    },
    hideLoading(text = '', delay = 500) {
      return new Promise(resolve => {
        setTimeout(() => {
          this.$bus.$emit('SET_LOADING', { show: false, text })
          resolve()
        }, delay)
      })
    },
    showToast(text, icon, delay = 1000) {
      if (typeof delay != 'number') {
        delay = 500
      }
      return new Promise(resolve => {
        this.$bus.$emit('SET_TOAST', { show: true, icon: icon, text: text })
        setTimeout(() => {
          this.$bus.$emit('SET_TOAST', { show: false, icon: '', text: '' })
          resolve()
        }, delay)
      })
    },
    async getToken() {
      return await this.$bridge
        .getToken({
          callbackName: 'getToken'
        })
        .then(tokenObj => {
          if (tokenObj.token) {
            return tokenObj.token
          } else {
            return false
          }
        })
    }
  }
}
